import { useCallback } from 'react'

import { useNavigation } from '~/hooks/useNavigation'
import { useCookieStore } from '~/store/cookieStore'

export const useViewAsOrg = () => {
  const navigate = useNavigation()
  const setActiveOrgId = useCookieStore((s) => s.setActiveOrgId)

  return useCallback(
    ({
      orgId,
      destinationPath,
    }: {
      orgId: string
      destinationPath: string
    }) => {
      setActiveOrgId(orgId)
      navigate(destinationPath)
    },
    [setActiveOrgId, navigate],
  )
}
